// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__rITBj","info":"Note_info__3VegF","note":"Note_note__1v1Fo","actions":"Note_actions__15HYR"};